import { AbgSxProps } from '@abg/typings';

export const accountMenuStyling: AbgSxProps = {
  zIndex: 1400,
  '.MuiPaper-root': {
    width: '340px',
    padding: '24px',
    marginTop: '26px',
    boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.10)',
  },
  '.MuiList-root': {
    padding: 0,
  },
};

export const closeIconStyling: AbgSxProps = {
  display: 'flex',
  padding: 0,
  marginLeft: 'auto',
  cursor: 'pointer',
  '.MuiSvgIcon-root': {
    fontSize: '16px',
  },
};
